import type { CollectionProgressResponseModel } from "@/features/collections/api/models/CollectionProgressResponseModel";
import { useHTTP, useHTTPQuery } from "@/lib/http";

export const useCollectionProgress = (collectionId: string) => {
	const http = useHTTP("Required");
	return useHTTPQuery({
		queryKey: ["collectionProgress", collectionId],
		queryFn: () => http<CollectionProgressResponseModel>({
			method: "GET",
			url: `/collection/${collectionId}/progress`
		})
	});
};
